import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useScrollReveal } from '../hooks/useScrollReveal';

export default function AboutSection() {
  const { t } = useLanguage();
  const ref = useScrollReveal();

  const stats = [
    { value: t('about.stat1_value'), label: t('about.stat1_label') },
    { value: t('about.stat2_value'), label: t('about.stat2_label') },
    { value: t('about.stat3_value'), label: t('about.stat3_label') },
  ];

  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B1E2E] via-[#0E2538] to-[#0B1E2E]" />

      <div ref={ref} className="reveal relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        {/* Caption */}
        <p className="text-sm uppercase tracking-widest text-[#42D2D9] font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
          {t('about.caption')}
        </p>
        <div className="section-line mb-8" />

        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left: Text */}
          <div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight text-white mb-8" style={{ fontFamily: 'Outfit, sans-serif' }}>
              {t('about.title')}
            </h2>
            <p className="text-base md:text-lg leading-relaxed text-slate-300 mb-12">
              {t('about.description')}
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6">
              {stats.map((stat, i) => (
                <div key={i} className="text-center lg:text-left">
                  <div className="metric-value text-3xl md:text-4xl mb-2">{stat.value}</div>
                  <div className="text-sm text-slate-400">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Quote */}
          <div className="glass-card p-8 md:p-10 rounded-lg">
            <div className="w-12 h-1 bg-[#42D2D9] mb-8" />
            <blockquote className="text-xl md:text-2xl text-white leading-relaxed mb-6 italic" style={{ fontFamily: 'Outfit, sans-serif' }}>
              {t('about.quote')}
            </blockquote>
            <p className="text-sm text-[#42D2D9] tracking-wide">
              {t('about.quote_author')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
